/* ============================================
   ATTITUDE DESIGN — ABOUT PAGE
   Gravity pile — clean rebuild
   ============================================ */

(function() {

  document.body.classList.add("about-page");

  /* Sections data injected from Liquid (translatable via locale files) */
  const _sectionsEl = document.getElementById('about-sections-data');
  const sections = _sectionsEl ? JSON.parse(_sectionsEl.textContent) : [];

  /* Physics constants */
  const CARD_H = 40;
  const CARD_H_EX = 100;
  const CARD_H_FORM = 220;
  const GAP = 6;
  const GRAV = 0.07;
  const BOUNCE = 0.08;
  const DAMP = 0.85;
  const DROP_DELAY = 160;

  /* Must match .about-stage's `bottom` offset and the footer's height
     in page-about.css, so the physics floor and the visual footer
     boundary always agree. */
  const FOOTER_RESERVE = 56;

  /* Rotations — 12 values */
  const ROTS = [-1.8, 1.2, -0.5, 2.0, -1.2, 1.6, -2.1, 0.8, -0.4, 1.4, -1.7, 0.9];

  /* X offsets from center — symmetric spread around center */
  const X_OFFSETS = [
    -100, 60, -150, 180, -50,
    120, -180, 30, -90, 150,
    -130, 80
  ];

  const stage = document.getElementById("aboutStage");
  const hint = document.getElementById("aboutHint");
  const resetBtn = document.getElementById("aboutReset");

  let stageW, stageH, floorY;
  let CARD_W = 240;
  let bodies = [];
  let cards = [];
  let raf = null;

  function measure() {
    const r = stage.getBoundingClientRect();
    stageW = r.width;
    stageH = r.height;
    /* The stage is already inset above the footer via CSS (bottom:
       FOOTER_RESERVE px), so floorY only needs a small internal
       margin — it does NOT subtract the footer height again. */
    floorY = stageH - 16;

    if (stageW < 480) {
      CARD_W = 200;
    } else if (stageW < 900) {
      CARD_W = 240;
    } else if (stageW < 1400) {
      CARD_W = 280;
    } else {
      CARD_W = 320;
    }
  }

  function getStartX(i) {
    const center = (stageW - CARD_W) / 2;
    return center + X_OFFSETS[i];
  }

  /* Single source of truth for resting position. Checks every other
     active, non-dragging card for horizontal overlap and, if found,
     treats the higher card's bottom edge (plus GAP) as the floor for
     this card. */
  function findFloor(idx) {
    const b = bodies[idx];
    let floor = floorY;

    for (let j = 0; j < bodies.length; j++) {
      if (j === idx) continue;
      const o = bodies[j];
      if (!o.active || o.dragging) continue;

      const xOverlap = Math.min(b.x + b.w, o.x + o.w) - Math.max(b.x, o.x);
      if (xOverlap > 12 && o.y < floor && o.y >= b.y) {
        floor = o.y - GAP;
      }
    }

    return floor;
  }

  /* Clamp a single card to its own column's floor. Returns true if
     the card had to move. Used both as a standalone pass and after
     every individual push below, so a card can never be left below
     its floor at any point during resolution — including floors
     created by a push that happens later in the same pass. */
  function clampOne(i) {
    const a = bodies[i];
    if (!a.active || a.dragging) return false;
    const maxY = findFloor(i) - a.h;
    if (a.y > maxY) {
      a.y = maxY;
      return true;
    }
    return false;
  }

  /* Synchronous, convergent overlap resolution. Run ONCE immediately
     after any card's height changes (expand/collapse) — never as a
     competing per-frame system. Repeats until a full pass produces no
     movement. Critically, every push is immediately followed by a
     clampOne() on the card that was just moved — without this, a push
     intended to resolve one overlap can shove a card past the floor,
     and that violation would only be caught on the NEXT pass (or not
     at all if the loop believed it had already converged), which is
     exactly what produced the residual overlaps after several
     sequential card expansions. */
  function resolveOverlapsSync() {
    for (let pass = 0; pass < 60; pass++) {
      let moved = false;

      for (let i = 0; i < bodies.length; i++) {
        if (clampOne(i)) moved = true;
      }

      for (let i = 0; i < bodies.length; i++) {
        const a = bodies[i];
        if (!a.active || a.dragging) continue;

        for (let j = 0; j < bodies.length; j++) {
          if (i === j) continue;
          const b = bodies[j];
          if (!b.active || b.dragging) continue;

          const xOverlap = Math.min(a.x + a.w, b.x + b.w) - Math.max(a.x, b.x);
          const yOverlap = Math.min(a.y + a.h, b.y + b.h) - Math.max(a.y, b.y);

          if (xOverlap > 12 && yOverlap > 0) {
            if (a.y < b.y) {
              b.y = a.y + a.h + GAP;
              clampOne(j);
            } else if (b.y < a.y) {
              a.y = b.y + b.h + GAP;
              clampOne(i);
            } else if (i < j) {
              b.y = a.y + a.h + GAP;
              clampOne(j);
            } else {
              a.y = b.y + b.h + GAP;
              clampOne(i);
            }
            moved = true;
          }
        }
      }

      if (!moved) break;
    }
  }

  function buildCards() {
    cards.forEach(function(c) { c.remove(); });
    cards = [];
    bodies = [];

    sections.forEach(function(s, i) {
      const b = {
        x: getStartX(i),
        y: -CARD_H - 20 - i * 50,
        vy: 0,
        vx: 0,
        rot: ROTS[i],
        w: CARD_W,
        h: CARD_H,
        active: false,
        landed: false,
        dragging: false,
        expanded: false,
        isForm: !!s.isForm,
        idx: i
      };
      bodies.push(b);

      const el = document.createElement("div");
      el.className = "gcard";
      el.style.zIndex = 10 + i;

      let bodyHTML = "";
      if (s.isForm) {
        var fl = s.formLabels || {};
        bodyHTML =
          '<div class="gc-body">' + s.body + '</div>' +
          '<div class="gc-form">' +
          '<form action="/contact" method="post" accept-charset="UTF-8">' +
          '<input type="hidden" name="form_type" value="contact">' +
          '<input type="hidden" name="utf8" value="&#x2713;">' +
          '<input type="text" name="contact[name]" placeholder="' + (fl.name || 'Name') + '" required>' +
          '<input type="text" name="contact[reason]" placeholder="' + (fl.reason || 'Why you are writing') + '" required>' +
          '<textarea name="contact[body]" placeholder="' + (fl.message || 'Say something') + '" rows="3" required></textarea>' +
          '<button type="submit">' + (fl.submit || 'Send it') + '</button>' +
          '</form>' +
          '<div class="gc-form-thanks">' + (fl.thanks || 'Noted.') + '</div>' +
          '</div>';
      } else {
        bodyHTML = '<div class="gc-body">' + s.body + '</div>';
      }

      el.innerHTML =
        '<div class="gcard-inner">' +
          '<div class="gc-stripe" style="background:' + s.stripe + ';"></div>' +
          '<span class="gc-num">' + s.num + '</span>' +
          '<span class="gc-title">' + s.title + '</span>' +
          bodyHTML +
        '</div>';

      el.addEventListener("click", function(e) {
        if (e.target.tagName === "INPUT" ||
            e.target.tagName === "TEXTAREA" ||
            e.target.tagName === "BUTTON") return;
        if (el._moved) return;

        const bodyEl = el.querySelector(".gc-body");
        const formEl = el.querySelector(".gc-form");
        const wasOpen = bodyEl.classList.contains("open") ||
                        (formEl && formEl.classList.contains("open"));

        document.querySelectorAll(".gc-body.open").forEach(function(x) { x.classList.remove("open"); });
        document.querySelectorAll(".gc-form.open").forEach(function(x) { x.classList.remove("open"); });
        bodies.forEach(function(x) {
          x.h = CARD_H;
          x.expanded = false;
        });

        if (!wasOpen) {
          if (s.isForm) {
            if (formEl) formEl.classList.add("open");
            b.h = CARD_H_FORM;
          } else {
            bodyEl.classList.add("open");
            b.h = CARD_H_EX;
          }
          b.expanded = true;

          document.querySelectorAll(".gcard").forEach(function(c) { c.style.zIndex = 10; });
          el.style.zIndex = 200;
        }

        /* Resolve any overlap caused by the height change synchronously,
           BEFORE physics resumes — this guarantees no visible overlap
           frame, unlike re-running collision checks only inside tick(). */
        resolveOverlapsSync();

        bodies.forEach(function(x) {
          if (!x.active || x.dragging) return;
          x.landed = false;
          if (x.vy === 0) x.vy = 0.3;
        });
      });

      makeDraggable(el, b);
      stage.appendChild(el);
      el.querySelector(".gcard-inner").style.width = CARD_W + "px";
      cards.push(el);
    });
  }

  function tick() {
    bodies.forEach(function(b, i) {
      if (!b.active || b.dragging) return;

      b.vy += GRAV;
      b.y += b.vy;
      b.x += b.vx;

      const targetFloor = findFloor(i) - b.h;

      if (b.y >= targetFloor) {
        b.y = targetFloor;
        b.vy = -b.vy * BOUNCE;
        b.vx *= DAMP;
        if (Math.abs(b.vy) < 0.06) { b.vy = 0; b.landed = true; }
        if (Math.abs(b.vx) < 0.02) b.vx = 0;
      }

      const minX = -24;
      const maxX = stageW - b.w + 24;
      if (b.x < minX) { b.x = minX; b.vx = Math.abs(b.vx) * 0.3; }
      if (b.x > maxX) { b.x = maxX; b.vx = -Math.abs(b.vx) * 0.3; }
    });

    render();
    raf = requestAnimationFrame(tick);
  }

  function render() {
    bodies.forEach(function(b, i) {
      if (!b.active) return;
      cards[i].style.left = Math.round(b.x) + "px";
      cards[i].style.top = Math.round(b.y) + "px";
      cards[i].style.transform = "rotate(" + b.rot + "deg)";
    });
  }

  function makeDraggable(el, b) {
    let sx, sy, sl, st, moved;

    function getPos(e) {
      const r = stage.getBoundingClientRect();
      return {
        x: (e.touches ? e.touches[0].clientX : e.clientX) - r.left,
        y: (e.touches ? e.touches[0].clientY : e.clientY) - r.top
      };
    }

    function start(e) {
      if (e.target.tagName === "INPUT" ||
          e.target.tagName === "TEXTAREA" ||
          e.target.tagName === "BUTTON") return;
      e.stopPropagation();
      const p = getPos(e);
      sx = p.x; sy = p.y;
      sl = b.x; st = b.y;
      moved = false;
      el._moved = false;
      b.dragging = true;
      b.landed = false;
      el.classList.add("held");

      document.querySelectorAll(".gcard").forEach(function(c) { c.style.zIndex = 10; });
      el.style.zIndex = 150;

      if (hint && !hint.classList.contains("gone")) {
        hint.classList.add("gone");
      }

      document.addEventListener("mousemove", move);
      document.addEventListener("mouseup", end);
      document.addEventListener("touchmove", move, { passive: false });
      document.addEventListener("touchend", end);
    }

    function move(e) {
      if (e.cancelable) e.preventDefault();
      const p = getPos(e);
      const dx = p.x - sx;
      const dy = p.y - sy;
      if (Math.abs(dx) > 5 || Math.abs(dy) > 5) {
        moved = true;
        el._moved = true;
      }
      b.x = sl + dx;
      b.y = st + dy;
    }

    function end() {
      b.dragging = false;
      b.vy = moved ? 1.5 : 0;
      b.vx = 0;
      el.classList.remove("held");
      document.removeEventListener("mousemove", move);
      document.removeEventListener("mouseup", end);
      document.removeEventListener("touchmove", move);
      document.removeEventListener("touchend", end);
      setTimeout(function() { el._moved = false; }, 100);
    }

    el.addEventListener("mousedown", start);
    el.addEventListener("touchstart", start, { passive: true });
  }

  function resetPile() {
    if (raf) cancelAnimationFrame(raf);
    measure();
    buildCards();

    document.querySelectorAll(".gc-body").forEach(function(x) { x.classList.remove("open"); });
    document.querySelectorAll(".gc-form").forEach(function(x) { x.classList.remove("open"); });

    bodies.forEach(function(b, i) {
      setTimeout(function() { b.active = true; }, i * DROP_DELAY);
    });

    tick();
  }

  function init() {
    measure();
    resetPile();

    resetBtn.addEventListener("click", function(e) {
      e.preventDefault();
      resetPile();
    });

    window.addEventListener("resize", function() {
      measure();
    });

    if (window.location.search.indexOf("contact_posted=true") !== -1) {
      setTimeout(function() {
        const card12 = cards[11];
        if (card12) {
          const formEl = card12.querySelector(".gc-form");
          const thanks = card12.querySelector(".gc-form-thanks");
          if (formEl) formEl.classList.add("open");
          if (thanks) thanks.classList.add("show");
          bodies[11].h = CARD_H_FORM;
          bodies[11].expanded = true;
        }
      }, 2500);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

})();
